var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWordpressLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.843 20c0 6.791 3.947 12.66 9.67 15.441L4.328 13.017A17.092 17.092 0 002.843 20zM31.583 19.134c0-2.12-.761-3.589-1.414-4.732-.87-1.413-1.686-2.61-1.686-4.023 0-1.578 1.197-3.046 2.882-3.046.076 0 .148.01.222.014a17.095 17.095 0 00-11.586-4.504c-5.995 0-11.268 3.075-14.336 7.733.403.012.782.02 1.104.02 1.795 0 4.573-.217 4.573-.217.925-.054 1.034 1.304.11 1.414 0 0-.93.109-1.964.163l6.248 18.585 3.755-11.261-2.673-7.325c-.924-.054-1.8-.163-1.8-.163-.924-.054-.816-1.468.109-1.413 0 0 2.833.217 4.52.217 1.794 0 4.572-.217 4.572-.217.926-.055 1.034 1.303.11 1.413 0 0-.931.11-1.964.163l6.2 18.444 1.712-5.719c.742-2.373 1.306-4.077 1.306-5.546z",
    fill: "#00769D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.302 21.501L15.154 36.46a17.155 17.155 0 0010.544-.274 1.513 1.513 0 01-.122-.236L20.302 21.5zM35.056 11.768c.074.547.115 1.133.115 1.764 0 1.742-.325 3.699-1.304 6.146l-5.241 15.153c5.1-2.975 8.532-8.501 8.532-14.83 0-2.984-.762-5.789-2.102-8.233z",
    fill: "#00769D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.974 0 0 8.972 0 20c0 11.03 8.973 20.001 20 20.001 11.028 0 20.002-8.972 20.002-20.001 0-11.028-8.974-20-20.001-20zm0 39.084C9.479 39.084.918 30.523.918 20 .917 9.478 9.478.917 20.001.917 30.523.917 39.083 9.477 39.083 20c0 10.523-8.56 19.084-19.082 19.084z",
    fill: "#00769D"
  })));
}

export default __webpack_public_path__ + "./fonts/wordpress-logo.75a347ff81ece50e89208cf9e73809c3.svg";
export { SvgWordpressLogo as ReactComponent };